import { FunctionComponent } from 'react';
import Button from 'components/UI/V3/Button/Button';
import styles from './ChannelIntegrationCard.module.scss';

type ChannelStatus = 'connected' | 'notConnected' | 'comingSoon';

interface ChannelIntegrationCardProps {
    icon: string;
    title: string;
    description: string;
    status: ChannelStatus;
    buttonLabel: string;
    buttonDisabled?: boolean;
    buttonLoading?: boolean;
    onClick?: () => void;
}

const BADGE_LABELS: Record<ChannelStatus, string> = {
    connected: 'Connected',
    notConnected: 'Not Connected',
    comingSoon: 'Coming Soon'
};

const ChannelIntegrationCard: FunctionComponent<ChannelIntegrationCardProps> = ({
    icon,
    title,
    description,
    status,
    buttonLabel,
    buttonDisabled,
    buttonLoading,
    onClick
}) => {
    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <img
                    src={icon}
                    alt={title}
                    className={styles.icon}
                />
                <span className={status === 'connected' ? styles.badgeConnected : styles.badgeDisconnected}>
                    {BADGE_LABELS[status]}
                </span>
            </div>
            <h3 className={styles.title}>{title}</h3>
            <p className={styles.description}>{description}</p>
            <Button
                label={buttonLabel}
                variant="black"
                size="medium"
                className={styles.button}
                disabled={buttonDisabled}
                isLoading={buttonLoading}
                onClick={onClick}
            />
        </div>
    );
};

export default ChannelIntegrationCard;
